import "./ForExtrusionFiltration.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import ExtrusionHero from "./sections/ExtrusionHero";
import ExtrusionGuide from "./sections/ExtrusionGuide";
import Articles from "./sections/Articles";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function ForExtrusionFiltrationPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="ForExtrusionFiltration" />
      <ExtrusionHero />
      <ExtrusionGuide />
      <Articles />
      <Quote />
      <Footer />
    </div>;
}